import { FeedbackConfigPayloadSchema } from '@/types/schema';

import { SESSION_FEEDBACK_PREFIX } from './constants';
import { FeedbackKey, FeedbackRow } from './types';

export function extractFeedbackKeys(rows: FeedbackRow[]): FeedbackKey[] {
  return (
    rows?.flatMap((row, rowIdx) => {
      const regularFeedbackKeys = Object.keys(row.feedback_stats ?? {});
      const sessionFeedbackKeys = Object.keys(
        row.session_feedback_stats ?? {}
      ).map((key) => `${SESSION_FEEDBACK_PREFIX}${key}`);

      return [...regularFeedbackKeys, ...sessionFeedbackKeys].map((key) => ({
        feedbackKey: key,
        rowIdx,
      }));
    }) ?? []
  );
}

export function getConfigMinMax(
  config?: FeedbackConfigPayloadSchema
): [number, number] {
  const configMin =
    config && 'min' in config && typeof config.min === 'number'
      ? config.min
      : 0;
  const configMax =
    config && 'max' in config && typeof config.max === 'number'
      ? config.max
      : 1;
  return [configMin, configMax];
}

export function getFeedbackAvg(
  rows: FeedbackRow[],
  rowIdx: number,
  type: string,
  lookupType: string
): number | undefined {
  const isSessionFeedback = type.startsWith(SESSION_FEEDBACK_PREFIX);

  return isSessionFeedback
    ? rows[rowIdx]?.session_feedback_stats?.[lookupType]?.avg ?? undefined
    : rows[rowIdx]?.feedback_stats?.[lookupType]?.avg ?? undefined;
}
